( function( global, $ ) {

    $(document).on('change' , '[gr-form] .field_recipient', function() {
        if ($('option:selected', this).data('slug') === 'ressources-humaines' || $('option:selected', this).data('slug') === 'human-resources') {
            $('[gr-form] .field_cv').show();
        } else {
            $('[gr-form] .field_cv').hide();
        }
    });

    $(document).on('change' , '[gr-form] #countries', function() {
        $('[gr-form] .select-states select').attr('disabled', 'disabled');
        $('[gr-form] .select-states').hide();

        var $select = $('[gr-form] #states-' + $(this).val());
        if ($select.length) {
            $select.find('select').removeAttr('disabled');
            $select.show();
        }
    });

}( window.groots, jQuery ));
